import { motion } from "framer-motion"
import Profile from "../component/profile"
import Notifications from "../component/notifications"
import Security from "../component/security"
import ConnectedAccounts from "../component/connected-accounts"
import LogoutComponent from "../component/logout.component"
import ChangePasswordComponent from "../component/change-password.component"
import ConfigurationComponent from "../component/configuration.component"
import { useCurrentUser } from "../../../shared/hooks/current-user.hook"
import OwnerSettingComponent from "../component/owner-setting.component"

const SettingsPage = () => {
  const [userInfo, userId, ownerInfo] = useCurrentUser()
  return (
    <main className="max-w-4xl mx-auto py-6 px-4 lg:px-8 mt-16">
      <Profile />

      <ChangePasswordComponent />

      {userInfo?.role?.key === "super_admin" && <ConfigurationComponent />}
      {/* {userInfo?.role?.key === "owner" && ownerInfo?.id === ownerInfo?.parentOwnerId && <OwnerSettingComponent id={ownerInfo?.parentOwnerId} />} */}
      {/* <Notifications />
				<Security />
				<ConnectedAccounts /> */}
      <LogoutComponent />
    </main>
  )
}

export default SettingsPage
